import { render, staticRenderFns } from "./HandbookIndex.vue?vue&type=template&id=9930b5d2"
import script from "./HandbookIndex.vue?vue&type=script&lang=js"
export * from "./HandbookIndex.vue?vue&type=script&lang=js"
import style0 from "./HandbookIndex.vue?vue&type=style&index=0&id=9930b5d2&prod&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports